import { CalendarMonthOutlined, PersonOutlineRounded, Tonality, VisibilityOffRounded } from "@mui/icons-material";
import { Divider, Link, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { DateTime } from "luxon";
import { IssuePrivacyType, Links } from "../../constants";
import { IssueDto } from "../../http";
import { ITeamSummary } from "../../models";
import { IssueCollaboratorsProperty, IssueDecisionMakerProperty, IssueStatusPicker, IssueTeamProperty } from ".";
import { ItemProperty } from "../itemProperties";

interface IProps {
  issue: IssueDto | undefined;
  isLoading?: boolean;
  onTeamChanged?: (team: ITeamSummary | null) => void;
}

const IssueProperties = (props: IProps) => {
  const theme = useTheme();

  return (
    <>
      {props.isLoading && (
        <Stack spacing={0.5} sx={{ px: 1, py: 0.5 }} divider={<Divider flexItem sx={{ borderStyle: "dashed" }} />}>
          <Skeleton width={"80%"} />
          <Skeleton width={"80%"} />
          <Skeleton width={"80%"} />
        </Stack>
      )}

      {!props.isLoading && props.issue && (
        <Stack spacing={0.5} sx={{ px: 1, py: 0.5 }} divider={<Divider flexItem sx={{ borderStyle: "dashed" }} />}>
          <ItemProperty labelIcon={<Tonality />} label="Status" rowLayoutOnSmallScreens>
            <IssueStatusPicker
              variant="select"
              issueGuid={props.issue.guid}
              status={props.issue.currentStatus}
              teamSlug={props.issue.assignedTeam?.slug}
              createdByUserGuid={props.issue.createdByUser.userId}
              disabled={!props.issue?.permissions.userCanEditStatus}
            />
          </ItemProperty>

          <ItemProperty labelIcon={<PersonOutlineRounded />} label="Creator">
            <Link href={Links.User(props.issue.createdByUser.userId)}>{props.issue.createdByUser.displayName}</Link>
          </ItemProperty>

          <IssueDecisionMakerProperty issue={props.issue} />

          <IssueTeamProperty issue={props.issue} onTeamChanged={props.onTeamChanged} />

          <IssueCollaboratorsProperty issue={props.issue} />

          <ItemProperty labelIcon={<CalendarMonthOutlined />} label="Created On">
            <Typography noWrap>
              {DateTime.fromISO(props.issue.createdDateTimeUtc, { zone: "utc" })
                .toLocal()
                .toLocaleString(DateTime.DATE_MED)}
            </Typography>
          </ItemProperty>

          {props.issue.privacy === IssuePrivacyType.Limited && (
            <ItemProperty labelIcon={<VisibilityOffRounded />} label="Privacy">
              <Typography sx={{ color: theme.palette.error.main }}>Limited</Typography>
            </ItemProperty>
          )}
        </Stack>
      )}
    </>
  );
};

export { IssueProperties };
